(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Categories', Categories);

    Categories.$inject = ['$resource'];

    function Categories ($resource) {
        var service = $resource('api/property/:id/categories', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();
